const camelCase = (value?: string): string => {
  if (!value) {
    return '';
  }
  return value.toLowerCase().replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
};

export default camelCase;
